import type { AxiosResponse } from 'axios'
import type { IRegisterUser, IResendEmail, IUserLogin } from '@/types/general'
import { http } from '@/services/http.service'

export async function login(user: IUserLogin): Promise<AxiosResponse> {
  return http.post('/users/sign_in', { user })
}

export async function logout(): Promise<AxiosResponse> {
  return http.delete('/users/sign_out')
}

export async function register(user: IRegisterUser): Promise<AxiosResponse> {
  return http.post('/users', { user })
}
export async function resendConfirmation(user: IResendEmail): Promise<AxiosResponse> {
  return http.post('/users/confirmation', { user })
}
export async function forgetPassword(user: IResendEmail): Promise<AxiosResponse> {
  return http.post('/users/password', { user })
}
